import MenuItem from '@mui/material/MenuItem'
import React, { useCallback } from 'react'
import { Link } from 'react-router-dom-v5-compat'

import CRMNotificationItem from './CRMNotificationItem'
import { notificationFocusUrl } from './notificationCenterViews'
import { useOptimizationReview } from './useOptimizationReview'

import type { Notification } from 'types/modules/notification-center/notification'

type NotificationBellPreviewItemProps = {
  notification: Notification
  /** Set on every row but the last, so the list reads as separate entries without a trailing rule. */
  divider?: boolean
  onSelect: (notification: Notification) => void
}

const NotificationBellPreviewItem = ({ notification, divider = false, onSelect }: NotificationBellPreviewItemProps) => {
  const handleClick = useCallback(() => onSelect(notification), [notification, onSelect])
  // A finished optimization has somewhere better to go than the inbox: its own comparison.
  const { reviewUrl } = useOptimizationReview(notification)

  // A real anchor: modifier-click opens the notification in a tab, and plain click still marks it read.
  return (
    <MenuItem
      component={Link}
      divider={divider}
      sx={{ whiteSpace: 'normal', py: 1.25 }}
      to={reviewUrl ?? notificationFocusUrl(notification.id)}
      onClick={handleClick}
    >
      <CRMNotificationItem notification={notification} />
    </MenuItem>
  )
}

export default NotificationBellPreviewItem
